import { render, staticRenderFns } from "./items-list.vue?vue&type=template&id=0cfe52f8&lang=pug&"
import script from "./items-list.vue?vue&type=script&lang=js&"
export * from "./items-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports